<div class="modal-body px-3 py-3">
  <form [formGroup]="saveSearchForm">
    <div class="d-flex justify-content-between mb-3">
      <div>
        <span class="font-weight-600">
          <i class="fa-regular fa-floppy-disk mr-1"></i>
          {{type == 'update' ? 'Update Search' : 'Save Search'}}
        </span>
        <!-- <span class="font-weight-600" *ngIf="searchName">
          Edit Name
        </span> -->
      </div>
      <span class="pointer">
        <i class="far fa-times f-16" (click)="closeModal('skip')"> </i>
      </span>
    </div>

    <div class="row mt-2">
      <div class="col heading-text">
        <p class="text-9696 mb-0">
          Please enter the name
        </p>
      </div>
    </div>

    <div class="row mt-2 mb-4">
      <div class="col">
        <input data-testid="auto-app-save-search-modal-input-1" type="text" class="wc-form-control no-shadow col-md icn-find mr-2" placeholder="Enter name here"
          formControlName="searchname" (keyup)="type != 'update' ? checkSearchNameDuplicacy() : null"
        />
      </div>
    </div>

    <div class="row">
      <div class="col position-relative">
        <div class="error-message text-danger position-absolute" style="top: -18px;">
          <p class="mb-1" [hidden]="!((saveSearchForm.controls['searchname'].dirty || saveSearchForm.controls['searchname'].touched) && saveSearchForm.controls['searchname'].hasError('required'))">Name is required</p>
          <p class="mb-1" [hidden]="!((saveSearchForm.controls['searchname'].dirty || saveSearchForm.controls['searchname'].touched) && saveSearchForm.controls['searchname'].hasError('htmlPresent'))">Input cannot contain HTML tags</p>
          <p class="mb-1" [hidden]="!((saveSearchForm.controls['searchname'].dirty || saveSearchForm.controls['searchname'].touched) && saveSearchForm.controls['searchname'].hasError('duplicate'))">Please enter different name</p>
          <p class="mb-1" [hidden]="!((saveSearchForm.controls['searchname'].dirty || saveSearchForm.controls['searchname'].touched) && saveSearchForm.controls['searchname'].hasError('minlength'))">Min. 2 characters required</p>
          <p class="mb-1" [hidden]="!((saveSearchForm.controls['searchname'].dirty || saveSearchForm.controls['searchname'].touched) && saveSearchForm.controls['searchname'].hasError('maxlength'))">Name cannot be more than 150 characters</p>
          <p class="mb-1" [hidden]="!((saveSearchForm.controls['searchname'].dirty || saveSearchForm.controls['searchname'].touched) && saveSearchForm.controls['searchname'].hasError('pattern') && !saveSearchForm.controls['searchname'].hasError('minlength'))">Invalid name</p>
        </div>
      </div>
    </div>

    <div class="row mt-1">
      <div class="col d-flex justify-content-end">
        <button data-testid="auto-app-save-search-modal-button-1" class="btn-trms-white mr-3" (click)="closeModal('skip')">Close</button>
        <button data-testid="auto-app-save-search-modal-button-2" class="btn-trms-small" (click)="saveSearch()">{{ type == 'update' ? 'Update' : 'Save' }}</button>
      </div>
    </div>
  </form>
</div>
